export default "/survey_assets/images/default-profile.70f705c79008a068110f67635defd8cf.png";